import { render } from "./organisation-support-cases.vue?vue&type=template&id=99832b9e"
import script from "./organisation-support-cases.vue?vue&type=script&lang=js"
export * from "./organisation-support-cases.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__